export default {
  admin: () => import("E:/code/my-blog/layouts/admin.vue").then(m => m.default || m),
  default: () => import("E:/code/my-blog/layouts/default.vue").then(m => m.default || m),
  none: () => import("E:/code/my-blog/layouts/none.vue").then(m => m.default || m),
  "smoke-bg": () => import("E:/code/my-blog/layouts/smokeBg.js").then(m => m.default || m)
}